module.exports = __webpack_public_path__ + "img/wiseEstimateWatermark.6c6d361a.png";